import { EventEmitter } from "fbemitter";
import { useListeners } from "./listeners";

export let Emitter: EventEmitter

export enum Event {
    DB_SUBMIT = 'dbSubmit',
    DB_SUBMIT_DONE = 'dbSubmitDone',
    DB_REMOVE = 'dbRemove',
    DB_REMOVE_DONE = 'dbRemoveDone',
    DB_ARCHIVE = 'dbArchive',
    DB_ARCHIVE_DONE = 'dbArchiveDone',
    UPDATE_STOCK = 'updateStock',
    EMPLOYEE_MISSING = 'employeeMissing',
    RESOLVE_REQUEST = 'resolveRequest'
}

export const useInitEmitter = () => {
    const { onDbSubmit, onDbSubmitDone, onDbRemove, onDbRemoveDone, onDbArchive, onDbArchiveDone, onUpdateStock, onEmployeeMissing } = useListeners()

    Emitter = new EventEmitter()
    Emitter.addListener(Event.DB_SUBMIT, onDbSubmit)
    Emitter.addListener(Event.DB_SUBMIT_DONE, onDbSubmitDone)
    Emitter.addListener(Event.DB_REMOVE, onDbRemove)
    Emitter.addListener(Event.DB_REMOVE_DONE, onDbRemoveDone)
    Emitter.addListener(Event.DB_ARCHIVE, onDbArchive)
    Emitter.addListener(Event.DB_ARCHIVE_DONE, onDbArchiveDone)
    Emitter.addListener(Event.UPDATE_STOCK, onUpdateStock)
    Emitter.addListener(Event.EMPLOYEE_MISSING, onEmployeeMissing)
    Emitter.addListener(Event.RESOLVE_REQUEST, onEmployeeMissing)
}
